/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  EnvironmentOutlined,
  MoreOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  Dropdown,
  Image,
  Input,
  Progress,
  Row,
  Select,
  Tag,
} from "antd";
import {
  DeleteIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../atoms/CustomIcons";

export default function Dashboard(props: any) {
  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/save-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          New deal
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/change-user.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Change account responsible
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Transfer to another client
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/archive-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Archive
        </Button>
      ),
    },
    {
      key: "6",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  console.log("props", props.data);

  function generateChartCard(graphData: any): import("react").ReactNode {
    return (
      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Stats</h3>
          <div>
            <Select
              suffixIcon={<SelectArrow />}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              allowClear
              placeholder="Type"
              defaultValue="past_year"
              popupMatchSelectWidth={false}
              options={[
                {
                  value: "past_month",
                  label: "Past month",
                },
                {
                  value: "past_6_months",
                  label: "Past 6 months",
                },
                {
                  value: "past_quarter",
                  label: "Past quarter",
                },
                {
                  value: "past_year",
                  label: "Past year",
                },
              ]}
            />
          </div>
        </div>
        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Total revenue</div>
                <div className="info">
                  ${graphData?.stats?.totalRevenue?.toLocaleString()}
                </div>
              </div>
              {/* <Progress percent={70} success={{ percent: 45, strokeColor: "#6454f4" }} showInfo={false} type="line" strokeColor="#44a6f1" trailColor="#e88a56" size={["100%", 12]} /> */}
              {/* <Progress
                percent={100}
                success={{
                  percent:
                    +`${graphData?.stats?.revenueBreakdown?.[0]?.percentage}`,
                  strokeColor: `${graphData?.stats?.revenueBreakdown?.[0]?.barColor}`,
                }}
                showInfo={false}
                type="line"
                size={["100%", 12]}
              /> */}
              <Progress
                percent={
                  graphData.stats.grossMargin.breakdown[1]
                    ? graphData.stats.grossMargin.breakdown[0].value +
                      graphData.stats.grossMargin.breakdown[1].value
                    : 100
                } //middle line
                success={{
                  percent: +`${
                    graphData.stats.grossMargin.breakdown[1]
                      ? graphData.stats.grossMargin.breakdown[0].value
                      : 100
                  }`, //First Line
                  strokeColor: `${graphData.stats.grossMargin.breakdown[0].barColor}`,
                }}
                showInfo={false}
                type="line"
                strokeColor={
                  graphData.stats.grossMargin.breakdown[1]
                    ? graphData.stats.grossMargin.breakdown[1].barColor
                    : "#E04949"
                }
                trailColor={
                  graphData.stats.grossMargin.breakdown[2]
                    ? graphData.stats.grossMargin.breakdown[2].barColor
                    : "#E04949"
                }
                size={["100%", 12]}
              />
              <div className="progressInfo">
                {graphData?.stats?.revenueBreakdown?.map((_item: any) => (
                  <div className="infoWrapper">
                    <Badge color={_item.barColor} text={_item.text} />
                    <div className="infoValue">
                      ${_item.value?.toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Gross margin & profit</div>
                <div className="info">
                  {graphData.stats.grossMargin.overall}%
                </div>
              </div>

              <Progress
                percent={
                  graphData.stats.grossMargin.breakdown[1]
                    ? graphData.stats.grossMargin.breakdown[0].value +
                      graphData.stats.grossMargin.breakdown[1].value
                    : 100
                } //middle line
                success={{
                  percent: +`${
                    graphData.stats.grossMargin.breakdown[1]
                      ? graphData.stats.grossMargin.breakdown[0].value
                      : 100
                  }`, //First Line
                  strokeColor: `${graphData.stats.grossMargin.breakdown[0].barColor}`,
                }}
                showInfo={false}
                type="line"
                strokeColor={
                  graphData.stats.grossMargin.breakdown[1]
                    ? graphData.stats.grossMargin.breakdown[1].barColor
                    : "#E04949"
                }
                trailColor={
                  graphData.stats.grossMargin.breakdown[2]
                    ? graphData.stats.grossMargin.breakdown[2].barColor
                    : "#E04949"
                }
                size={["100%", 12]}
              />
              <div className="progressInfo">
                {graphData.stats.grossMargin.breakdown.map((_item: any) => (
                  <div className="infoWrapper">
                    <Badge color={_item.barColor} text={_item.text} />
                    <div className="infoValue">{_item.value}%</div>
                  </div>
                ))}
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Win ratio</div>
                <div className="info">{graphData.stats.winRatio.value}%</div>
              </div>

              <Progress
                percent={100}
                success={{
                  percent: graphData.stats.winRatio.value,
                  strokeColor: "#00A07D",
                }}
                showInfo={false}
                type="line"
                strokeColor="#E04949"
                size={["100%", 12]}
              />
              <div className="progressInfo">
                <div className="infoWrapper">
                  <Badge color="#00A07D" text="Wins:" />
                  <div className="infoValue">
                    {graphData.stats.winRatio.wins}
                  </div>
                </div>
                <div className="infoWrapper">
                  <Badge color="#E04949" text="Losses:" />
                  <div className="infoValue">
                    {graphData.stats.winRatio.losses}
                  </div>
                </div>
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard threeValues">
              <div className="profileProgressHeader">
                <div className="label">Accounts receivable</div>
                <div className="info">
                  ${graphData.stats.accountsReceivable.total?.toLocaleString()}
                </div>
              </div>
              {/* <Progress percent={100} success={{ percent: +`${graphData.stats.grossMargin.breakdown.percentage}`, strokeColor: `${graphData.stats.grossMargin.breakdown.barColor}` }} showInfo={false} type="line" size={["100%", 12]} /> */}

              <Progress
                percent={
                  (graphData.stats.accountsReceivable.breakdown[0].value /
                    graphData.stats.accountsReceivable.total) *
                    100 +
                  (graphData.stats.accountsReceivable.breakdown[1].value /
                    graphData.stats.accountsReceivable.total) *
                    100
                } //middle line
                success={{
                  percent: +`${
                    (graphData.stats.accountsReceivable.breakdown[0].value /
                      graphData.stats.accountsReceivable.total) *
                    100
                  }`, //First Line
                  strokeColor: `${graphData.stats.accountsReceivable.breakdown[0].barColor}`,
                }}
                showInfo={false}
                type="line"
                strokeColor={
                  graphData.stats.accountsReceivable.breakdown[1].barColor
                }
                trailColor={
                  graphData.stats.accountsReceivable.breakdown[2].barColor
                }
                size={["100%", 12]}
              />
              <div className="progressInfo">
                {graphData.stats.accountsReceivable.breakdown.map(
                  (_item: any) => (
                    <div className="infoWrapper">
                      <Badge color={_item.barColor} text={_item.text} />
                      <div className="infoValue">
                        ${_item.value?.toLocaleString()}
                      </div>
                    </div>
                  )
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </Card>
    );
  }

  return (
    <div className="profileWrapper">
      {generateChartCard(props.data)}

      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Properties</h3>
          <Button icon={<PlusOutlined />} className="outlined-btn" />
        </div>

        <Row gutter={[0, 4]}>
          <Col span={24}>
            <Card className="dealsCard client__profile__card">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <div className="filterSearch">
                  <Input
                    prefix={<SearchIcon />}
                    placeholder="Search properties"
                    allowClear
                  />
                </div>
                <div>
                  <Select
                    suffixIcon={<SelectArrow />}
                    menuItemSelectedIcon={
                      <TickIcon style={{ color: "#00A07D" }} />
                    }
                    showSearch
                    allowClear
                    placeholder="Type"
                    defaultValue="past_year"
                    popupMatchSelectWidth={false}
                    options={[
                      {
                        value: "past_month",
                        label: "Past month",
                      },
                      {
                        value: "past_6_months",
                        label: "Past 6 months",
                      },
                      {
                        value: "past_quarter",
                        label: "Past quarter",
                      },
                      {
                        value: "past_year",
                        label: "Past year",
                      },
                    ]}
                  />
                </div>
              </div>
              {props.data.properties?.map((x: any) => {
                let color = "#00A07D";
                if (x.status === "Pending deal") {
                  color = "#E88A56";
                } else if (x.status === "Unengaged") {
                  color = "#D2BE4F";
                }
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                    className="deal_standard_box"
                  >
                    <div className="dealsInfo propertyInfo">
                      <Image
                        src={x.image}
                        preview={false}
                        className="mainAvatar"
                      />
                      <div className="propertyText">
                        <h4 style={{ display: "flex", alignItems: "center" }}>
                          {x.name}{" "}
                          <Tag color={color} style={{ marginLeft: "8px" }}>
                            {x.status}
                          </Tag>
                        </h4>
                        <p>
                          <EnvironmentOutlined /> {x.address}
                        </p>

                        <div className="managerDetail">
                          Account manager:
                          <div className="managerText">
                            <Image
                              src="/images/dummy/manager.png"
                              preview={false}
                              width={20}
                            />
                            {x.accountManager}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="dealsRightWrapper">
                      <div className="dealsInnerCard">
                        <Card className="dealsInnerCardItem">
                          <div className="innerLabel">Total revenue</div>
                          <span className="time">(past 12 mo)</span>
                          <h4>${x.totalRevenuePast12Mo.toLocaleString()}</h4>
                        </Card>
                        <Card className="dealsInnerCardItem">
                          <div className="innerLabel">GM</div>
                          <span className="time">(past 12 mo)</span>
                          <h4>{x.grossMarginPast2Mo}%</h4>
                        </Card>
                      </div>

                      <div className="dropdownDeals">
                        <Dropdown
                          menu={{ items }}
                          trigger={["click"]}
                          placement="bottomRight"
                          className="actionButton"
                        >
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            onKeyDown={(e) => e.stopPropagation()}
                            style={{
                              padding: "6px",
                            }}
                            className="only_icon"
                            icon={<MoreOutlined />}
                          />
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
}
